(() => {
	// eslint-disable-next-line no-console
	/* global Swiper */

	// ============================================
	// 共通変数
	// ============================================
	//メディアクエリ
	const breakPointPc = 768;
	const mql = window.matchMedia(`(min-width: ${breakPointPc}px)`);

	// ============================================
	// スライダー
	// ============================================
	const swiperInit = () => {
		// Swiperを先に生成（autoplayは停止状態で）
		const mySwiper_thumb = new Swiper('[data-thumb-swiper]', {
			slidesPerView: "auto",
			watchSlidesProgress: true,
		});

		const mySwiper_main = new Swiper('[data-view-swiper]', {
			slidesPerView: 1,
			spaceBetween: 10,
			thumbs: {
				swiper: mySwiper_thumb,
			},
		});

	};

	// ============================================
	// キャラクター画像表示切り替え
	// ============================================
	const changeIconView = () => {

		// ============================================
		// 共通設定
		// ============================================
		const prefix = 'data-icon_shrink';
		const target = document.querySelector(`[${prefix}-target]`);

		// キャラクター画像がない場合は実行しない
		if (!target) {
			return;
		}

		// 最大サイズ時に付与されるクラス
		const isMaxClassName = 'is-max';
		// 最小サイズ時に付与されるクラス
		const isMinClassName = 'is-min';
		// アイコン化時に付与されるクラス
		const isShrinkClassName = target.dataset.icon_shrinkTarget;

		// 虫眼鏡→画像表示の操作をしたか確認するフラグ
		let isOpened = false;

		// 画面幅チェック
		const checkWindow = () => {
			return mql.matches;
		};

		// ============================================
		// 画像の表示切り替え
		// ============================================
		const updateView = () => {

			// SPの場合は処理を止める
			if (!checkWindow()) {
				// 表示制御のクラスを外す
				target.classList.remove(
					isMaxClassName,
					isMinClassName,
					isShrinkClassName
				);
				return;
			}

			// 一度アイコン化している場合は表示制御をしない
			if (isOpened) {
				return;
			}

			// 画面高さを取得
			const initViewHeight = window.innerHeight;

			// サイドバーの最大値と最小値をremで設定
			const rootFontSize = parseFloat(
				getComputedStyle(document.documentElement).fontSize
			);
			// サイドバーの高さ + sticky時の上部空き
			const heightMax = (85.2 + 4) * rootFontSize;
			const heightMin = (81.2 + 4) * rootFontSize;

			// すでに付与されている表示制御があれば削除
			target.classList.remove(
				isMaxClassName,
				isMinClassName,
				isShrinkClassName
			);

			// 画面の高さに応じて表示制御クラスを付与
			if (
				initViewHeight >= heightMax
			) {
				// 最大表示
				target.classList.add(isMaxClassName);
			}
			else if (
				heightMax > initViewHeight &&
				initViewHeight > heightMin
			) {
				// 中間表示
				target.classList.add(isMinClassName);
			}
			else {
				// アイコン表示
				target.classList.add(isShrinkClassName);
			}
		};

		// アイコン化しているtargetをクリックした場合、クラスを外す
		target.addEventListener('click', () => {
			if (target.classList.contains(isShrinkClassName)) {
				target.classList.remove(isShrinkClassName);
				// 処理を行ったことを記憶させる
				isOpened = true;
			}
		})

		// リサイズ時は遅延をかけて実行
		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);

			resizeTimer = setTimeout(() => {
				updateView();
			}, 200);
		});

		// SP <=> PC に画面幅が変わった場合も処理を行う
		mql.addEventListener('change', () => {
			updateView();
		});

		// 初回実行
		updateView();
	}

	// ============================================
	// 実行
	// ============================================
	swiperInit();
	changeIconView();
})();
